namespace advisorop.components.common {

    export interface IFeeStructureItem {
        feeRate: number;
        amountThreshold: number | null;
    }

    export interface IFeeStructure {
        orionFeeScheduleId?: number | null;
        name?: string;
        description?: string;
        items: IFeeStructureItem[];
    }

    export class CuFeeStructureController {
        feeStructure: string; // JSON string input
        readOnly: boolean = false;
        onChange: any;
        showTieredSelector: boolean = false; // New: control visibility of tiered selector

        feeStructureData: IFeeStructureItem[] = [];
        isValid: boolean = true;
        validationMessage: string = "";

        // New properties for tiered fee schedule selector
        tieredFeeSchedules: domains.IBillScheduleFullDto[] = [];
        selectedTieredSchedule: domains.IBillScheduleFullDto = null;
        loadingSchedules: boolean = false;
        cannotFindOrionFee: boolean = false;
        manualFeeDescription: string = ""; // Description when fee is not found in Orion
        isInitializing: boolean = false; // Track initialization state

        static $inject = ["$scope", "orionService", "generalService"];
        constructor(private $scope: ng.IScope,
            private orionService: services.OrionService,
            private generalService: services.GeneralService) {
            /*
            this.dgFeeStructure = {
                bindingOptions: {
                    dataSource: "vm.feeStructureData",
                    readOnly: "vm.readOnly"
                },
                editing: {
                    mode: "row",
                    allowAdding: true,
                    allowDeleting: true,
                    allowUpdating: true,
                    useIcons: true
                },
                paging: { enabled: false },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                sorting: {
                    mode: "none"
                },
                onToolbarPreparing: (e) => {
                    // Add Clear All button to the toolbar
                    if (this.feeStructureData && this.feeStructureData.length > 0) {
                        e.toolbarOptions.items.push({
                            location: "after",
                            widget: "dxButton",
                            options: {
                                icon: "trash",
                                hint: "Clear All",
                                onClick: () => {
                                    this.clearAllFeeStructure();
                                }
                            }
                        });
                    }
                },
                columns: [
                    {
                        dataField: "amountThreshold",
                        caption: "Up To Amount",
                        dataType: "number",
                        format: { type: "currency", precision: 2 },
                        allowEditing: true,
                        editorOptions: {
                            step: 1000,
                            format: { type: "currency", precision: 2 }
                        },
                        customizeText: (cellInfo) => {
                            if (cellInfo.value === null || cellInfo.value === undefined || cellInfo.value === '') {
                                return "No Limit";
                            }
                            const numValue = typeof cellInfo.value === 'number' ? cellInfo.value : parseFloat(String(cellInfo.value));
                            if (isNaN(numValue)) {
                                return "No Limit";
                            }
                            return cellInfo.valueText;
                        },
                        setCellValue: (rowData, value) => {
                            // Treat empty string, undefined, or NaN as null
                            if (value === '' || value === undefined || (typeof value === 'number' && isNaN(value))) {
                                rowData.amountThreshold = null;
                            } else {
                                rowData.amountThreshold = value;
                            }
                        }
                    },
                    {
                        dataField: "feeRate",
                        caption: "Fee (%)",
                        dataType: "number",
                        validationRules: [
                            { type: "required", message: "Fee is required" },
                            { type: "range", min: 0, max: 100, message: "Fee must be between 0 and 100" }
                        ],
                        editorOptions: {
                            step: 0.01,
                            format: { type: "decimal", precision: 2 },
                            showClearButton: true
                        },
                        customizeText: (cellInfo) => {
                            if (cellInfo.value === null || cellInfo.value === undefined) return '';
                            const numValue = typeof cellInfo.value === 'number' ? cellInfo.value : parseFloat(String(cellInfo.value));
                            return numValue.toFixed(2) + '%';
                        }
                    }
                ],
                onRowInserted: (e) => {
                    this.syncDataFromGrid(e.component);
                    this.validateAndSort();
                    this.$scope.$applyAsync();
                },
                onRowUpdated: (e) => {
                    this.syncDataFromGrid(e.component);
                    this.validateAndSort();
                    this.$scope.$applyAsync();
                },
                onRowRemoved: (e) => {
                    this.syncDataFromGrid(e.component);
                    this.validateAndSort();
                    this.$scope.$applyAsync();
                },
                onEditorPreparing: (e) => {
                    if (this.readOnly) {
                        e.editorOptions.disabled = true;
                    }
                    // For feeRate field, clear default value when editing starts
                    if (e.dataField === "feeRate" && e.row && e.row.isNewRow) {
                        e.editorOptions.value = undefined;
                    }
                },
                onInitNewRow: (e) => {
                    // Set default values for new row
                    e.data.feeRate = undefined;
                    e.data.amountThreshold = undefined;
                }
            };
            */
        }

        $onInit(): void {
            this.isInitializing = true;
            this.parseFeeStructure();
            this.validateFeeStructure();
            
            // Load tiered fee schedules from Orion if selector is shown
            if (this.showTieredSelector && !this.readOnly) {
                this.loadTieredFeeSchedules();
            }
            this.isInitializing = false;
        }

        $onChanges(changes): void {
            if (changes.feeStructure && !changes.feeStructure.isFirstChange()) {
                this.isInitializing = true;
                this.parseFeeStructure();
                this.validateFeeStructure();
                this.isInitializing = false;
            }
            /*
            if (changes.readOnly && !changes.readOnly.isFirstChange()) {
                // Update grid readonly state
                if (this.dgFeeStructure) {
                    this.dgFeeStructure.editing.allowAdding = !this.readOnly;
                    this.dgFeeStructure.editing.allowDeleting = !this.readOnly;
                    this.dgFeeStructure.editing.allowUpdating = !this.readOnly;
                }
            }
            */
            if (changes.showTieredSelector && !changes.showTieredSelector.isFirstChange()) {
                // Load schedules when selector becomes visible
                if (this.showTieredSelector && !this.readOnly && this.tieredFeeSchedules.length === 0) {
                    this.loadTieredFeeSchedules();
                }
            }
        }

        // New: Load tiered fee schedules from Orion
        loadTieredFeeSchedules(): void {
            this.loadingSchedules = true;
            this.orionService.getTieredFeeSchedules()
                .then(response => {
                    this.tieredFeeSchedules = response.data;
                    console.log("Loaded tiered fee schedules:", this.tieredFeeSchedules);
                    
                    // Try to auto-select schedule if we have fee structure data with an orionFeeScheduleId
                    if (this.feeStructure) {
                        this.trySelectScheduleFromFeeStructure();
                    }
                })
                .catch(err => {
                    this.generalService.showError(err);
                    toastr.error("Failed to load tiered fee schedules from Orion");
                })
                .finally(() => {
                    this.loadingSchedules = false;
                    this.$scope.$applyAsync();
                });
        }

        // New: Try to select schedule from loaded fee structure
        private trySelectScheduleFromFeeStructure(): void {
            try {
                const parsed = JSON.parse(this.feeStructure);
                if (parsed && typeof parsed === 'object' && 'items' in parsed) {
                    const feeStructure = parsed as IFeeStructure;
                    if (feeStructure.orionFeeScheduleId && feeStructure.orionFeeScheduleId > 0) {
                        const matchingSchedule = this.tieredFeeSchedules.find(s => s.id === feeStructure.orionFeeScheduleId);
                        if (matchingSchedule) {
                            this.isInitializing = true;
                            this.selectedTieredSchedule = matchingSchedule;
                            this.isInitializing = false;
                            console.log(`Auto-selected Orion fee schedule: ${matchingSchedule.name} (ID: ${matchingSchedule.id})`);
                        } else {
                            console.warn(`Could not find Orion fee schedule with ID: ${feeStructure.orionFeeScheduleId}`);
                        }
                    }
                }
            } catch (e) {
                // Ignore parsing errors - fee structure might be in legacy format or invalid
            }
        }

        // New: Handle tiered schedule selection change from dropdown
        onTieredScheduleChanged(): void {
            // Only apply if not initializing and a schedule is selected
            if (!this.isInitializing && this.selectedTieredSchedule) {
                this.applyTieredSchedule();
            }
        }

        // New: Check if Select button should be enabled
        canSelectSchedule(): boolean {
            return this.selectedTieredSchedule != null && 
                   this.selectedTieredSchedule.details != null && 
                   this.selectedTieredSchedule.details.length > 0;
        }

        // New: Apply selected tiered schedule to fee structure
        applyTieredSchedule(): void {
            if (!this.canSelectSchedule()) {
                toastr.warning("Please select a valid tiered fee schedule");
                return;
            }

            // Convert Orion BillScheduleDetailDto to our IFeeStructureItem format
            // Orion uses minimumAmount/maximumAmount ranges, we use amountThreshold (upper limit per tier)
            
            // Sort details by minimumAmount to ensure proper order
            const sortedDetails = this.selectedTieredSchedule.details
                .slice()
                .sort((a, b) => (a.minimumAmount || 0) - (b.minimumAmount || 0));

            this.feeStructureData = sortedDetails.map((detail, index) => {
                // Check if this is the last tier (no limit)
                // Orion uses a very large number (9999999999) to represent "no limit"
                const isNoLimitTier = detail.maximumAmount >= 9999999999 || 
                                     index === sortedDetails.length - 1;

                // Convert from decimal to percentage and round to 2 decimal places to avoid floating point errors
                const feeRate = Math.round((detail.rate || 0) * 100 * 100) / 100;

                return {
                    feeRate: feeRate,
                    amountThreshold: isNoLimitTier ? null : detail.maximumAmount
                };
            });

            // Validate that ranges are continuous and properly structured
            let hasError = false;
            for (let i = 0; i < sortedDetails.length - 1; i++) {
                const current = sortedDetails[i];
                const next = sortedDetails[i + 1];
                
                // Verify that the next tier's minimum equals current tier's maximum
                if (current.maximumAmount !== next.minimumAmount) {
                    toastr.warning(`Gap detected in fee schedule between $${current.maximumAmount.toLocaleString()} and $${next.minimumAmount.toLocaleString()}`);
                    hasError = true;
                    break;
                }
            }

            if (hasError) {
                toastr.error("Selected fee schedule has discontinuous ranges. Please review the schedule.");
                return;
            }

            // Uncheck the "cannot find" checkbox since we found a schedule
            this.cannotFindOrionFee = false;

            // Sort and validate
            this.validateAndSort();
            
            toastr.success(`Applied fee schedule: ${this.selectedTieredSchedule.name}`);
        }

        // New: Clear all fee structure data
        clearAllFeeStructure(): void {
            // Confirm with user before clearing
            if (!confirm("Are you sure you want to clear all fee tiers? This action cannot be undone.")) {
                return;
            }

            // Clear the fee structure data
            this.feeStructureData = [];
            
            // Reset the Orion dropdown selection
            this.selectedTieredSchedule = null;
            
            // Reset the cannot find flag
            this.cannotFindOrionFee = false;
            
            // Validate and notify changes
            this.validateFeeStructure();
            this.notifyChange();
            
            toastr.info("Fee structure cleared");
        }

        // New: Handle cannot find Orion fee checkbox change
        onCannotFindOrionFeeChanged(): void {
            // Force immediate scope update
            this.$scope.$applyAsync(() => {
                if (this.cannotFindOrionFee) {
                    // Clear any selected schedule and fee data
                    this.selectedTieredSchedule = null;
                    this.feeStructureData = [];
                    // Don't clear manualFeeDescription - preserve user's text
                    
                    // Notify that a new fee needs to be created in Orion
                    toastr.info("Fee schedule needs to be created in Orion. Please describe the fee structure.");
                } else {
                    // Clear manual description when reverting to Orion selection
                    this.manualFeeDescription = "";
                }
                
                // Validate and notify changes
                this.validateFeeStructure();
                this.notifyChange();
            });
        }

        // New: Handle manual fee description change
        onManualFeeDescriptionChanged(): void {
            this.validateFeeStructure();
            this.notifyChange();
        }

        parseFeeStructure(): void {
            if (!this.feeStructure) {
                this.feeStructureData = [];
                this.cannotFindOrionFee = false;
                this.manualFeeDescription = "";
                this.selectedTieredSchedule = null;
                this.isValid = false;
                this.validationMessage = null; // "Fee structure must have at least one tier with 'No Limit' amount (general fee)";
                return;
            }

            try {
                const parsed = JSON.parse(this.feeStructure);
                
                // Check if it's the new format (object with items property)
                if (parsed && typeof parsed === 'object' && 'items' in parsed) {
                    const feeStructure = parsed as IFeeStructure;
                    
                    // Parse items array
                    this.feeStructureData = (feeStructure.items || []).map(item => ({
                        feeRate: parseFloat(item.feeRate as any) || 0,
                        amountThreshold: item.amountThreshold === null || item.amountThreshold === undefined ? null : parseFloat(item.amountThreshold as any)
                    }));
                    
                    // Set checkbox state based on orionFeeScheduleId
                    this.cannotFindOrionFee = !feeStructure.orionFeeScheduleId || feeStructure.orionFeeScheduleId <= 0;
                    
                    // Load manual description if present
                    this.manualFeeDescription = this.cannotFindOrionFee ? (feeStructure.description || "") : "";
                    
                    // Try to find and select the matching schedule if we have an ID and schedules are loaded
                    if (feeStructure.orionFeeScheduleId && feeStructure.orionFeeScheduleId > 0) {
                        if (this.tieredFeeSchedules.length > 0) {
                            // Schedules already loaded - select immediately
                            this.selectedTieredSchedule = this.tieredFeeSchedules.find(s => s.id === feeStructure.orionFeeScheduleId) || null;
                        }
                    } else {
                        this.selectedTieredSchedule = null;
                    }
                }
                // Legacy format - array of items
                else if (Array.isArray(parsed)) {
                    this.feeStructureData = parsed.map(item => ({
                        feeRate: parseFloat(item.feeRate) || 0,
                        amountThreshold: item.amountThreshold === null || item.amountThreshold === undefined ? null : parseFloat(item.amountThreshold)
                    }));
                    this.cannotFindOrionFee = false;
                    this.manualFeeDescription = "";
                    this.selectedTieredSchedule = null;
                } else {
                    this.feeStructureData = [];
                    this.cannotFindOrionFee = false;
                    this.manualFeeDescription = "";
                    this.selectedTieredSchedule = null;
                    this.isValid = false;
                    this.validationMessage = "Invalid fee structure format - expected array or object with items";
                }
            } catch (e) {
                // Invalid JSON - initialize empty structure
                this.feeStructureData = [];
                this.cannotFindOrionFee = false;
                this.manualFeeDescription = "";
                this.selectedTieredSchedule = null;
                this.isValid = false;
                this.validationMessage = "Invalid JSON format - please add a valid fee structure tier";
            }
        }

        /*
        syncDataFromGrid(gridInstance: any): void {
            // Get the actual data from the grid's dataSource
            const dataSource = gridInstance.getDataSource();
            if (dataSource) {
                const items = dataSource.items();
                this.feeStructureData = items.map(item => ({
                    feeRate: item.feeRate,
                    amountThreshold: item.amountThreshold === undefined ? null : item.amountThreshold
                }));
            }
        }
        */


        validateAndSort(): void {
            // Ensure all items have amountThreshold property (even if undefined)
            this.feeStructureData.forEach(item => {
                if (!item.hasOwnProperty('amountThreshold')) {
                    item.amountThreshold = null;
                }
            });

            // Sort by amountThreshold (nulls last)
            this.feeStructureData.sort((a, b) => {
                if (a.amountThreshold === null || a.amountThreshold === undefined) return 1;
                if (b.amountThreshold === null || b.amountThreshold === undefined) return -1;
                return a.amountThreshold - b.amountThreshold;
            });

            this.validateFeeStructure();
            this.notifyChange();
        }

        validateFeeStructure(): void {
            this.isValid = true;
            this.validationMessage = "";

            // If user cannot find Orion fee, require manual description but allow empty fee structure
            if (this.cannotFindOrionFee) {
                if (!this.manualFeeDescription || this.manualFeeDescription.trim().length === 0) {
                    this.isValid = false;
                    this.validationMessage = "Please describe the fee structure that needs to be created in Orion";
                    return;
                }
                this.isValid = true;
                this.validationMessage = "Fee schedule needs to be created in Orion - proposal can be saved for later completion";
                return;
            }

            if (this.feeStructureData.length === 0) {
                this.isValid = false;
                this.validationMessage = "Orion Fee Schedule not assigned";
                return;
            }

            // Count No Limit tiers
            const noLimitCount = this.feeStructureData.filter(item => item.amountThreshold === null || item.amountThreshold === undefined).length;
            if (noLimitCount === 0) {
                this.isValid = false;
                this.validationMessage = "Fee structure must have exactly one tier with 'No Limit' amount (general fee)";
                return;
            }
            if (noLimitCount > 1) {
                this.isValid = false;
                this.validationMessage = "Fee structure can only have one tier with 'No Limit' amount";
                return;
            }

            // Check that all fees are valid
            for (let i = 0; i < this.feeStructureData.length; i++) {
                const item = this.feeStructureData[i];
                
                if (item.feeRate === null || item.feeRate === undefined || item.feeRate < 0 || item.feeRate > 100) {
                    this.isValid = false;
                    this.validationMessage = `Invalid fee at tier ${i + 1}: must be between 0 and 100`;
                    return;
                }
            }

            // Check that No Limit tier is last after sorting (only if multiple tiers)
            if (this.feeStructureData.length > 1) {
                const lastItem = this.feeStructureData[this.feeStructureData.length - 1];
                if (lastItem.amountThreshold !== null && lastItem.amountThreshold !== undefined) {
                    this.isValid = false;
                    this.validationMessage = "The 'No Limit' tier must be the last tier (leave amount empty)";
                    return;
                }
            }

            // Check ranges for non-null amounts
            let previousAmount = 0;
            for (let i = 0; i < this.feeStructureData.length; i++) {
                const item = this.feeStructureData[i];

                if (item.amountThreshold !== null && item.amountThreshold !== undefined) {
                    if (item.amountThreshold <= previousAmount) {
                        this.isValid = false;
                        this.validationMessage = `Tier ${i + 1}: Amount ($${item.amountThreshold.toLocaleString()}) must be greater than previous tier ($${previousAmount.toLocaleString()})`;
                        return;
                    }
                    previousAmount = item.amountThreshold;
                }
            }

            // All validations passed
            this.isValid = true;
            this.validationMessage = "";
        }

        notifyChange(): void {
            // Build the new fee structure format
            const feeStructure: IFeeStructure = {
                orionFeeScheduleId: this.cannotFindOrionFee ? null : (this.selectedTieredSchedule?.id || null),
                name: this.cannotFindOrionFee ? null : (this.selectedTieredSchedule?.name || null),
                description: this.cannotFindOrionFee ? this.manualFeeDescription : (this.selectedTieredSchedule?.description || null),
                items: this.feeStructureData.map(item => ({
                    feeRate: item.feeRate,
                    amountThreshold: item.amountThreshold
                }))
            };
            
            const jsonString = JSON.stringify(feeStructure);
            
            if (this.onChange) {
                this.onChange({
                    feeStructure: jsonString,
                    isValid: this.isValid,
                    validationMessage: this.validationMessage
                });
            }
        }

        getFeeStructureJson(): string {
            return JSON.stringify(this.feeStructureData);
        }

        isValidFeeStructure(): boolean {
            this.validateFeeStructure();
            return this.isValid;
        }
    }

    class CuFeeStructure implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.controller = CuFeeStructureController;
            this.controllerAs = "vm";
            this.bindings = {
                feeStructure: "<",  // JSON string input
                readOnly: "<",       // boolean for read-only mode
                onChange: "&",        // callback when fee structure changes
                showTieredSelector: "<" // New: boolean to show/hide tiered schedule selector
            };
            this.templateUrl = "spa/shared/common/cu-fee-structure.html";
        }
    }

    angular.module(Constants.APP).component("cuFeeStructure", new CuFeeStructure());
}
